export default "__VITE_ASSET__D$kxxkW0__"